import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

let manage;
let popup;
let assign;
let topBar;
let app;
const filter = require('./filter').default;

if (__MANAGE__) {
  manage = require('./manage').default; // eslint-disable-line
  popup = require('./popup').default; // eslint-disable-line
} else {
  assign = require('./assign').default; // eslint-disable-line
  topBar = require('./topBar').default; // eslint-disable-line
  app = require('./app').default; // eslint-disable-line
}

let reducerObject = {
  routing: routerReducer,
  filter
};

reducerObject = (__MANAGE__) ?
 { ...reducerObject, popup, manage } : { ...reducerObject, assign, topBar, app };

const rootReducer = combineReducers(reducerObject);

export default rootReducer;



// WEBPACK FOOTER //
// ./src/state/modules/reducer.js